import { HTLCPublicClient, } from '@train-protocol/sdk';
import { getNode } from './helpers';
import { getUserLockDetails } from './public/getUserLockDetails';
import { getSolverLockDetails } from './public/getSolverLockDetails';
import { recoverSwap } from './public/recoverSwap';
import { getTransaction } from './public/getTransaction';
export class AztecHTLCPublicClient extends HTLCPublicClient {
    constructor(config) {
        super();
        this.rpcUrl = config.rpcUrl;
        this.signer = config.signer;
        this.consensusOptions = { minQuorum: 1, batchSize: 1 };
    }
    // ── Read Operations ────────────────────────────────────────────────
    async getUserLockDetails(params) {
        return getUserLockDetails(this.rpcUrl, this.getNode(), this.signer, params);
    }
    async getSolverLockDetails(params, nodeUrl) {
        return getSolverLockDetails(this.rpcUrl, this.signer, params, nodeUrl);
    }
    async recoverSwap(txHash, network) {
        return recoverSwap(this.rpcUrl, this.getNode(), this.signer, txHash, network);
    }
    // ── Public Helpers ─────────────────────────────────────────────────
    async getTransaction(txHash) {
        return getTransaction(this.getNode(), txHash);
    }
    // ── Protected Helpers ──────────────────────────────────────────────
    getNode() {
        if (!this._node) {
            this._node = getNode(this.rpcUrl);
        }
        return this._node;
    }
}
